import React, { useState } from "react";
import Stepper from "./Stepper";

export default function Verification({ refetch, init = {}, initStep = 1 }) {
  const [state, setState] = useState({});
  const [activeStep, setActiveStep] = useState(initStep);

  const handleNext = () =>
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const handleState = (state = {}) => {
    setState((prev) => ({ ...prev, ...state }));
  };

  return (
    <Stepper
      state={{ ...init, ...state }}
      refetch={refetch}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      handleState={handleState}
    />
  );
}
